import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { TranslateTableModel } from '../models/config/translate_table.model';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

import { environment } from '../../environments/environment';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';
import { AuthGaurdService } from './auth-gaurd.service';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TranslateTableService {

  opts = [];

  private host = environment.apiUrl+"config/translatetable";
  public loggedinUser: string = '';

  constructor(private http: HttpClient,
    private logger: LoggerService,private authGaurdService: AuthGaurdService) {
      this.loggedinUser = this.authGaurdService.loginUser();
     }

  public addTrans(formData: FormData): Observable<TranslateTableModel> {
    return this.http.post<TranslateTableModel>(`${this.host}/addtrans`, formData);
  }

  public updateFieldName(formData: FormData): Observable<TranslateTableModel> {
    return this.http.post<TranslateTableModel>(`${this.host}/updatefiledname`, formData);
  }

  public updateFieldValue(formData: FormData): Observable<TranslateTableModel> {
    return this.http.post<TranslateTableModel>(`${this.host}/updatefiledvalue`, formData);
  }

  getFieldNames() {
    this.opts = [];
    let url = this.host + '/getfieldnames';
    return this.opts.length ?
      of(this.opts) :
      this.http.get<any>(url).pipe(tap(data => this.opts = data))
  }

  public getTransList() {
    let url = this.host + '/gettranslatetablelist';
    return this.http.get<TranslateTableModel[]>(url)
      .pipe(
        map((data: TranslateTableModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }
  public getExcelTransList() {
    let url = this.host + '/getexceltranslatetablelist';
    return this.http.get<TranslateTableModel[]>(url)
      .pipe(
        map((data: TranslateTableModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }
  public getTransFieldValuesList(field_name:string) {
    let url = this.host + '/getfieldvalueslist?field_name='+field_name;
    return this.http.get<TranslateTableModel[]>(url)
      .pipe(
        map((data: TranslateTableModel[]) => {
          return data;
        }), catchError(error => {
          this.logger.info(' error ==> ', error);
          return throwError('Something went wrong!');
        })
      )
  }

  public createForm(addTranslateTable: TranslateTableModel): FormData {
    var datestr = (new Date(addTranslateTable.effective_date)).toUTCString();
    console.log(addTranslateTable.field_name);
    const formData = new FormData();
    formData.append('id', addTranslateTable.id);
    formData.append('field_name', addTranslateTable.field_name);
    formData.append('field_value', addTranslateTable.field_value);
    formData.append('description', addTranslateTable.description);
    formData.append('field_short_name', addTranslateTable.field_short_name);
    formData.append('effective_status', addTranslateTable.effective_status);
    formData.append('effective_date', datestr);
    formData.append('currentUser',this.loggedinUser);
    return formData;
  }

  public createTransForm(addTranslateTable: TranslateTableModel,fname:string): FormData {
    var datestr = (new Date(addTranslateTable.effective_date)).toUTCString();
    const formData = new FormData();
    formData.append('id', addTranslateTable.id);
    formData.append('field_name', addTranslateTable.field_name);
    formData.append('field_value', addTranslateTable.field_value);
    formData.append('description', addTranslateTable.description);
    formData.append('field_short_name', addTranslateTable.field_short_name);
    formData.append('effective_date', datestr);
    formData.append('fname', fname);
    formData.append('currentUser',this.loggedinUser);
    return formData;
  }

  public handleError(error: { error: { message: string; }; status: any; message: any; }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}


